import {BaseContainerModel} from '../../base-container.model';
import {
  bl_b2b_payment_request_stmt_to_internal_po_matching_link_RowClass
} from '../../../dbschema/index';

export class PmtStmtIntPoMatchingLinkContainer extends BaseContainerModel {
  bl_b2b_payment_request_stmt_to_internal_po_matching_link: bl_b2b_payment_request_stmt_to_internal_po_matching_link_RowClass = new bl_b2b_payment_request_stmt_to_internal_po_matching_link_RowClass();

}
